import React, { Component } from 'react';
import PostCard from '../components/wiki/postCard';
import Footer from '../components/footer';
import BlogAPI from '../api/blog';
import PostCardSpecial from '../components/wiki/postCardSpecial';

export default class Encyclopedia extends Component {

    state = {
        specials: [],
        posts: [],
        page: 1,
        totalPageCount: 0,
        limit: 8,
        postsLoadError: false,
        pagination: [],
    }

    setTotalPageCount = (postsCount) => {
        this.setState({ totalPageCount: Math.ceil(postsCount / this.state.limit) }, () => this.setPagination())
    }

    loadPosts = (special = false) => {
        const blogAPI = new BlogAPI()
        const limit = special ? 4 : this.state.limit
        const page = special ? 1 : this.state.page
        blogAPI.getPostsList(limit, page, special).then((response) => {
            if (response.success) {
                // If the request is for special posts
                // Then just set the specials and not the posts
                if (special) {
                    this.setState({ specials: response.data.results })
                } else {
                    this.setTotalPageCount(response.data.count)
                    this.setState({ posts: response.data.results })
                }
            } else {
                this.setState({ postsLoadError: true })
            }
        })
    }

    componentDidMount() {
        document.title = this.props.texts["encyclopediaTitle"]
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');

        // Check for page parameter in url
        // Load posts after page state has been set
        if (page) {
            this.setState({ page: page }, () => {
                this.loadPosts()
                // Load Specials too
                this.loadPosts(true)
            })
        } else {
            this.loadPosts()
            // Load Specials too
            this.loadPosts(true)
        }
    }

    setPagination = () => {
        let pagination = [Number(this.state.page)]
        let before = this.state.page - 1 <= 3 ? this.state.page - 1 : 3
        let after = this.state.page + 6 - before <= this.state.totalPageCount ? this.state.page + 6 - before : this.state.totalPageCount - this.state.page

        if (after < 3 && this.state.page - before > 0) {
            before = this.state.page - 6 + after > 0 ? this.state.page - 6 + after : this.state.page - 1
        }

        for (let i = 0; i < before; i++) {
            pagination.unshift(Number(this.state.page) - i - 1)
        }

        for (let i = 0; i < after; i++) {
            pagination.push(Number(this.state.page) + i + 1)
        }

        this.setState({ pagination: pagination })
    }

    pageHandler = (page) => {
        if (page !== Number(this.state.page)) {
            this.setState({ page: page }, () => this.loadPosts())
        }
    }

    render() {
        let specials = this.state.specials.map((post) => <PostCardSpecial key={"specialPost" + post.id} postData={post} />)
        let posts = this.state.posts.map((post) => <PostCard key={"post" + post.id} postData={post} />)
        let pagination = this.state.pagination.map((page => <li key={"page" + page} onClick={() => this.pageHandler(page)}>{page}</li>))


        return (
            <div className="body-daneshname">
                <div className="header-daneshname">
                    <a href="/" title="back to Home">
                        <img src="./static/img/daneshname-logo.png" alt="page-logo" />
                    </a>
                </div>
                <div className="background-images-first">
                    <img src="/static/img/Mockup.png" alt="mockup" />
                </div>
                <div className="hot-title">
                    <h1>{this.props.texts["specialPosts"]}</h1>
                    <div className="container">
                        <div className="row">
                            {specials}
                        </div>
                    </div>
                </div>
                <div className="other-card container">
                    <div className="row mt-5">
                        {posts}
                    </div>
                    <br />
                    <br />
                    <div className="row">
                        <div className="number-of-page">
                            <ul className="body-pagination">
                                {this.state.page > 1 &&
                                    <li className="left-arrow" onClick={() => this.pageHandler(this.state.page - 1)}>
                                        <svg viewBox="0 0 29 21" version="1.1">
                                            <g transform="matrix(1,0,0,1,-12930,-10180.4)">
                                                <g transform="matrix(1,0,0,2.40797,5253.64,8042.17)">
                                                    <g transform="matrix(2.48383,0,0,1.0315,7458.23,-327.708)">
                                                        <path d="M93.397,1179.29C93.397,1178.87 92.927,1178.61 92.576,1178.86L88.233,1182.35C87.947,1182.56 87.95,1182.98 88.233,1183.19L92.576,1186.67C92.88,1186.9 93.398,1186.72 93.398,1186.25L93.397,1184.48L98.007,1183.99C99.585,1183.75 99.664,1181.85 98.007,1181.55L93.398,1181.06L93.397,1179.29Z" />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </li>
                                }


                                {pagination}

                                {this.state.page < this.state.totalPageCount &&
                                    <li className="right-arrow" onClick={() => this.pageHandler(this.state.page + 1)}>
                                        <svg viewBox="0 0 29 21" version="1.1">
                                            <g transform="matrix(1,0,0,1,-13381.8,-10180.4)">
                                                <g transform="matrix(1,0,0,2.40797,5253.64,8042.17)">
                                                    <g transform="matrix(2.48383,0,0,1.0315,7850.92,-327.651)">
                                                        <path d="M117.638,1186.19C117.638,1186.62 118.113,1186.87 118.46,1186.61L122.804,1183.13C123.091,1182.92 123.088,1182.49 122.804,1182.29L118.46,1178.8C118.152,1178.58 117.637,1178.77 117.637,1179.23L117.638,1181L113.026,1181.49C111.447,1181.73 111.368,1183.63 113.026,1183.92L117.637,1184.42L117.638,1186.19Z" />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </li>
                                }

                            </ul>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}